import CmmApi from "../apis/cmm.api";
import useAuth from "./useAuth";

export default function useHandleSaleLink() {
  const { ceoInfo } = useAuth();
  const handleSaleLink = async () => {
    const res = await CmmApi.getManagerCodeByShopIdx(ceoInfo.shop_idx);
    if (res.data) {
      //using set timeout bc window.open not working on safari
      setTimeout(() => {
        window.open(
          `${process.env.REACT_APP_SALE_ENPOINT}/apply/${res.data}/shop/${ceoInfo.shop_idx}`,
          "_blank",
          "rel=noopener noreferrer"
        );
      });
    }
  };
  return { handleSaleLink };
}
